export default __webpack_public_path__ + "static/media/ngo.6399e46b.jpg";